import {useState} from 'react';
import Anchor from '../../common/component/Anchor';
import SingleText from '../../common/component/SingleText';
import VideoAuto from '../../common/component/VideoAuto';
import {PromotionVideo, Video} from '../../common/type';
import {PageInfo, routeTo} from '../../common/util/PageRouter';

export interface IpVideoProps {
  eventIpVideoWrapperClassName?: string;
  promotionVideo?: PromotionVideo;
  eventIpVideo?: Video;
  landingUrl?: PageInfo | string;
  onShowIpVideo?: (showVideo: boolean) => void;
  onClickIpVideo?: () => void;
  onClickIpVideoMute?: (isMute: boolean) => void;
  onClickIpVideoPlay?: () => void;
}

export default function IpVideo({
  eventIpVideoWrapperClassName,
  promotionVideo,
  eventIpVideo,
  landingUrl,
  onShowIpVideo,
  onClickIpVideo,
  onClickIpVideoMute,
  onClickIpVideoPlay,
}: IpVideoProps) {
  const {title, subTitle, horizontalSources} = promotionVideo ?? {};
  const {sources} = eventIpVideo ?? {};
  const [isShow, setIsShow] = useState(true);
  const [isMuted, setIsMuted] = useState(true);

  const handleClickAnchor = () => {
    onClickIpVideo?.();
    landingUrl && routeTo(landingUrl);
  };

  const handleAnimationEnd = () => {
    if (!isShow) {
      onShowIpVideo?.(false);
    }
  };

  const handleVideoEnded = () => {
    setIsShow(false);
  };

  const onIntersection = (isIntersecting: boolean) => {
    setIsShow(isIntersecting);
    if (!isIntersecting) {
      setIsMuted(true);
      onShowIpVideo?.(false);
    }
  };

  const handleClickMute = (isMute: boolean) => {
    onClickIpVideoMute?.(isMute);
    setIsMuted(isMute);
  };

  const handleClickPlay = () => {
    onClickIpVideoPlay?.();
  };

  const animateClassName = cn({
    'animate-fadeIn2': isShow,
    'animate-fadeOut2': !isShow,
  });

  return (
    <>
      <Anchor
        onClick={handleClickAnchor}
        className={cn(
          'z-2 absolute inset-0',
          animateClassName,
          eventIpVideoWrapperClassName
        )}
        onAnimationEnd={handleAnimationEnd}
      >
        <VideoAuto
          sources={sources || horizontalSources || []}
          /**
           * ios에서 비디오 위를 덮는 요소의 z-index가 높아도 비디오 밑으로 깔리는 버그가 있다.
           * (특정 조건일때만 그런것 같은데 원인을 찾지 못함) 이때 비디오의 z-index 를 -1 로 주면 해결된다.
           */
          className="h-full bg-black relative -z-1 w-auto left-1/2 -translate-x-1/2"
          onEnded={handleVideoEnded}
          onIntersection={onIntersection}
          onClickMute={handleClickMute}
          thresholdShow={0.1}
          showMuteButton
          muteButtonClassName={animateClassName}
          isMute={isMuted}
          onPlay={handleClickPlay}
        />
        {!eventIpVideo && (
          <div
            className={cn(
              'w-full h-[170px]',
              'flex flex-col justify-end',
              'absolute left-0 bottom-0',
              'pl-14 pb-14',
              'bg-gradient-to-b from-black/0 to-black/80'
            )}
          >
            <SingleText
              className={cn('s22-bold-white leading-26', TEXT_MAX_WIDTH_CN)}
            >
              {title}
            </SingleText>
            <SingleText
              className={cn(
                's12-regular-white leading-14 mt-3 opacity-80',
                TEXT_MAX_WIDTH_CN
              )}
            >
              {subTitle}
            </SingleText>
          </div>
        )}
      </Anchor>
    </>
  );
}

const TEXT_MAX_WIDTH_CN = 'max-w-[calc(100%-56px)]';
